import { MDText } from 'i18n-react';

import { ReactComponent as LaurelLeftIcon } from './icons/laurel-left.svg';
import { ReactComponent as LaurelRightIcon } from './icons/laurel-right.svg';
import { StarRating } from './StarRating/StarRating';
import { getReviewCountText } from './DealerRating.helpers';
import LocalTexts from './DealerRating.texts.json';

import styles from './DealerRating.module.scss';

const LocalT = new MDText(LocalTexts);

type DealerRatingProps = {
  averageRating?: number;
  reviewCount?: number;
};

export const DealerRating = ({ averageRating = 0, reviewCount = 0 }: DealerRatingProps) => {
  const clampedRating = Math.max(0, Math.min(averageRating, 5));
  const reviewCountText = getReviewCountText(reviewCount);
  const isTopDealer = clampedRating >= 4;

  return reviewCount > 0 ? (
    <div className={styles.wrapper}>
      {isTopDealer
        && <div className={styles.topDealer}>
          <LaurelLeftIcon aria-hidden focusable={false} />
          {LocalT.translate('dealerRating.topDealer')}
          <LaurelRightIcon aria-hidden focusable={false} />
        </div>}
      <div className={styles.container}>
        <div className={styles.ratingContainer}>
          <span>{clampedRating.toFixed(1)}</span>
          <StarRating rating={clampedRating} />
        </div>
        <span>{LocalT.translate('dealerRating.reviews', { reviewCountText })}</span>
      </div>
    </div>
  ) : null;
};
